import "./Footer.scss";
import React from "react";
import { FaLocationArrow, FaMobileAlt, FaEnvelope } from "react-icons/fa";
import Payment from "../../assets/payments.png";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="col">
          <div className="title">About</div>
          <div className="text">
            Welcome to Sonic, your ultimate hub for tech excellence! Dive into
            a world of sonic wonders with our curated selection of headphones,
            earphones, speakers, soundbars, smart watches and more. Explore cutting-edge
            technology and trendsetting designs that redefine your
            experience. Whether you're after wireless earbuds, powerful
            soundbars, or any audio accessory that elevates your beats, Sonic is
            where style meets tech. Unleash the power of quality gadgets and
            embrace a lifestyle where every note matters. Sonic, where
            innovation harmonizes with your passion for gadgets. Tune into a
            symphony of possibilities; shop at Sonic!🎶🔊 #Sonic Journey
          </div>
        </div>
        <div className="col">
          <div className="title">Contact</div>
          <div className="c-item">
            <FaLocationArrow />
            <div className="text">905 Lancaster St.Troy, NY 12180</div>
          </div>
          <div className="c-item">
            <FaEnvelope />
            <div className="text">sonicofficial.org@gmail.com</div>
          </div>
          <div className="c-item">
            <FaMobileAlt />
            <div className="text"> (315) 555 1234/ (315) 505 202</div>
          </div>
        </div>
        <div className="col">
          <div className="title">Categories</div>
          <span className="text">Headphones</span>
          <span className="text">Smart Watches</span>
          <span className="text">Bluetooth Speaker</span>
          <span className="text">Wireless Earbuds</span>
          <span className="text">Home Theatre</span>
        </div>
        <div className="col">
          <div className="title">Pages</div>
          <span className="text">Home</span>
          <span className="text">About</span>
          <span className="text">Privacy Policy</span>
          <span className="text">Returns and Refund Policy</span>
          <span className="text">Contact Us</span>
        </div>
      </div>
      <div className="bottom-bar">
        <div className="bottom-bar-content"> &copy; SONIC 2024 BY LUXE FOUNDATION <img src={Payment} alt="payment" /></div>
      </div>
    </footer>
  );
};

export default Footer;
